import { useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { nanoid } from 'nanoid'

import { firebase } from '../../core/services'

import {
  ANALYTICS_EVENT_CATEGORIES,
  ANALYTICS_EVENTS,
} from '../../common/constants'
import { apolloService } from '../../common/services'

import { UPDATE_MENU_CURATION_TASK_MUTATION } from '../graphql/mutations'
import { UPDATE_MENU_CURATION_TASK } from '../redux/action-types'

const useUpdateMenuCurationTaskMutation = () => {
  const sessionId = useRef(nanoid())
  const dispatch = useDispatch()

  const { isUpdateLoading, updateError } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )

  const mutate = useCallback(
    (id, data) => {
      firebase.logEvent(
        ANALYTICS_EVENTS.MENU_CURATOR_UPDATE_MENU_TASK
          .MENU_CURATOR_START_UPDATE_MENU_TASK,
        {
          sessionId: sessionId.current,
          eventCategory:
            ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_UPDATE_MENU_TASK,
        },
      )

      apolloService.mutate({
        mutation: UPDATE_MENU_CURATION_TASK_MUTATION,
        variables: { id, data },
        dispatch,
        action: UPDATE_MENU_CURATION_TASK,
        onSuccess: () =>
          firebase.logEvent(
            ANALYTICS_EVENTS.MENU_CURATOR_UPDATE_MENU_TASK
              .MENU_CURATOR_END_UPDATE_MENU_TASK,
            {
              sessionId: sessionId.current,
              eventCategory:
                ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_UPDATE_MENU_TASK,
            },
          ),
      })
    },
    [dispatch],
  )

  return [mutate, { isUpdateLoading, updateError }]
}

export default useUpdateMenuCurationTaskMutation
